import React from "react";
import { useNavigate } from "react-router-dom";

const TrackList = () => {
  const navigate = useNavigate();
  return (
    <div style={{ padding: "24px" }}>
      <div style={{ background: "#fff", borderRadius: "12px", padding: "24px", boxShadow: "0 1px 4px rgba(0,0,0,0.08)" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "24px" }}>
          <h3 style={{ margin: 0 }}>Tracks</h3>
          <button onClick={() => navigate("/track/create")} style={{ background: "#0d9488", color: "#fff", border: "none", borderRadius: "8px", padding: "10px 20px", cursor: "pointer", fontSize: "14px" }}>
            + Upload Track
          </button>
        </div>
        <p style={{ color: "#888" }}>Track list coming soon.</p>
      </div>
    </div>
  );
};

export default TrackList;
